import axiosInstance from './axiosConfig';
import { LoginCredentials, RegisterData, AuthResponse } from '../types/auth';

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await axiosInstance.post('/auth/login', credentials);
    return response.data;
  },

  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await axiosInstance.post('/auth/register', data);
    return response.data;
  },

  async logout(): Promise<void> {
    try {
      await axiosInstance.post('/auth/logout');
    } catch (error) {
      // Even if logout fails, clear local storage

    } finally {
      // Always clear local storage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  async getCurrentUser(): Promise<any> {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  },

  // Helper function to check if user is authenticated
  isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    return !!token;
  },

  // Helper function to get token
  getToken(): string | null {
    return localStorage.getItem('token');
  },

  // Helper function to clear auth data
  clearAuth(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}; 